import { AppDispatch } from '../../data/store';
import { WebSocketSessionInfo } from './webSocketService';
import { type DriverLocation } from '../../data/models/driver-location.model';
import { setDriverLocation } from '../../data/driver.slice';

enum DriverLocationEventType {
  DriverLocationUpdate = 'DriverLocationUpdate',
}

type DriverLocationDetail = {
  transportationProviderID: number;
  tripLegReferenceID: string;
  tripLegID: number;
  driverID: number;
  clientID: string;
  passengerID: string;
  reservationID: number;
  driverLocation: {
    eta: number;
    etaCalculatedOnUTC: string;
    etaDestinationType: string;
    latitude: number;
    longitude: number;
    tripLegReferenceID: string;
  };
};

function updateDriverLocation(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: DriverLocationEventType,
  detail: DriverLocationDetail,
) {
  const { driverLocation, tripLegID, driverID } = detail;

  const location: DriverLocation = {
    tripLegID,
    driverID,
    latitude: driverLocation.latitude?.toString(),
    longitude: driverLocation.longitude?.toString(),
    estimatedTimeOfArrivalSeconds: driverLocation?.eta,
    etaCalculatedOnUTC: driverLocation?.etaCalculatedOnUTC,
    etaDestinationType: driverLocation?.etaDestinationType,
  };

  switch (detailType) {
    case DriverLocationEventType.DriverLocationUpdate:
      dispatch(setDriverLocation(location));
      break;
  }
}

export { DriverLocationEventType, updateDriverLocation };
